import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  Adress,
  Customer,
  FBOOrderById,
  FBOWriteOffPreviewResponse,
  OrdersResponse,
  Product,
  ResponceUploadFile,
} from './types'
import { Productavailable } from '../orders/types'

export class FBOService {
  static getOrdersFBO(config?: AxiosRequestConfig): Promise<OrdersResponse> {
    return apiService.get<OrdersResponse>(`order/marketplace-shipments`, config)
  }

  static getOrdersFBOById(
    orderId?: string,
  ): Promise<AxiosResponse<FBOOrderById>> {
    return apiService.get<AxiosResponse<FBOOrderById>>(
      `shipping/${orderId}/bulk`,
    )
  }

  static uploadFile(
    data: FormData,
  ): Promise<AxiosResponse<ResponceUploadFile[]>> {
    return apiService.post<AxiosResponse<ResponceUploadFile[]>>(
      '/fbo/parse',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  }

  static previewWriteOffFile(
    data: FormData,
  ): Promise<FBOWriteOffPreviewResponse> {
    return apiService.post<FBOWriteOffPreviewResponse>(
      '/fbo/orders/from-file/preview',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  }

  static createWriteOffFromFile(data: FormData): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/fbo/orders/from-file', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  static createOrder(order: {
    storeId: string
    label: string
    customer: Customer
    address: Adress
    shippingMethod: null | string
    paymentPrice: null
    comment: null
    digitalProducts: []
    parentId: null
    products: Product[]
  }): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/order/create`, { order })
  }

  static updatingBalances(
    productVariationIds: string[],
    storeId: string,
  ): Promise<
    AxiosResponse<{ productVariationId: string; stockQuantity: number }[]>
  > {
    return apiService.post<
      AxiosResponse<{ productVariationId: string; stockQuantity: number }[]>
    >(`/products/variation/stocks`, {
      productVariationIds,
      storeId,
    })
  }

  static collectAnOrder(
    orderID: string,
    data: { products: string[] },
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(
      `/shipping/${orderID}/bulk-checking`,
      data,
    )
  }

  static getAvailableProductOptions(
    id: string,
  ): Promise<AxiosResponse<Productavailable>> {
    return apiService.get<AxiosResponse<Productavailable>>(
      `/products/available/${id}`,
    )
  }

  static getProductVariation(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse> {
    return apiService.get<AxiosResponse>(
      `/products/available/${id}/variation`,
      config,
    )
  }
}
